import script from "./BaseHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseHeader.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__